import { render } from "./FacilityManagementTab.vue?vue&type=template&id=2a00c2d0"
import script from "./FacilityManagementTab.vue?vue&type=script&lang=js"
export * from "./FacilityManagementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__